import { useEffect, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SweetAlertService from '../../../services/SweetAlertService';
import { getRequiredErrorMessage } from '../Shared/Constants/AdminModuleConstants';
import WorkHourService from "../Shared/Services/WorkHourService";

export const AddWorkHour = () => {
    const [countryList, setCountryList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [subRoleList, setSubRoleList] = useState([]);
    const [contractList, setContractList] = useState([]);
    const [role, setRole] = useState(1);

    useEffect(() => {
        WorkHourService.getCountryData().then((response) => {
            setCountryList(response.data.data);
        });
        WorkHourService.getAllRoleSubRoleContract().then((response) => {
            setSubRoleList(response.data.subRoles);
            setRoleList(response.data.roles)
            setContractList(response.data.contracts)
        })
    }, []);
    const navigate = useNavigate();
    const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm(
        {
            defaultValues: { countryId: 0, roleId: 1, subRoleId: 1, contractId: 1 }
        });

    const onformSubmit = (data: any) => {
        data.countryId = Number(data.countryId);
        //data.subRoleId = Number(data.subRoleId);
        //data.contractId = Number(data.contractId);
        //data.roleId = Number(data.roleId);
        WorkHourService.addWorkHour(data).then((response) => {
            if (response.data > 0) {
                navigate("/workhour");
            } else {
                console.log("Error : Something went wrong while adding contracts " + response.data);
            }
            // Reset form
            reset();
        }).catch(error => {
            if (error) {
                SweetAlertService.error("Error", error.response.data.errors[""]);
            }
        })
    }

    const onRoleChange = (event: any) => {
        setRole(event.target.value);
        setValue("subRoleId", event.target.value == 1 ? 1 : 4);
    };

    return (
        <>
            <div className="card card-default" >
                <div className="card-header">
                    <h4>Create contract</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit(onformSubmit)}>
                        <div className="form-group row">
                            <label className="col-lg-3 control-label">
                                Country
                            </label>
                            <div className="col-lg-9">
                                <select className="form-select"
                                    {...register("countryId", {
                                        required: getRequiredErrorMessage("Country"),
                                    })}>
                                    <option value="">please select</option>
                                    if (countryList.length)
                                    {
                                        (countryList).map((e: any) => (
                                            <option value={e.id} key={e.id}> {e.name}</option>
                                        ))
                                    }
                                </select>
                                {errors.countryId && (
                                    <span className="help-block m-b-none text-danger field-validation-valid">
                                        {errors.countryId.message?.toString()}
                                    </span>
                                )}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label">Role</label>
                            <div className="col-lg-9">
                                <div className="d-flex flex-row">
                                    GP
                                </div>
                                {/*<select className="form-select"*/}
                                {/*    {...register("roleId")}*/}
                                {/*    onChange={(e) => onRoleChange(e)}*/}
                                {/*>*/}
                                {/*    if (roleList.length)*/}
                                {/*    {*/}
                                {/*        (roleList).map((e: any) => (*/}
                                {/*            <option value={e.id} key={e.id}> {e.name}</option>*/}
                                {/*        ))*/}
                                {/*    }*/}
                                {/*</select>*/}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label">Sub Role</label>
                            <div className="col-lg-9">
                                <div className="d-flex flex-row">
                                    Salaried GP
                                </div>
                                {/*<select className="form-select"*/}
                                {/*    {...register("subRoleId")}>*/}
                                {/*    if (subRoleList.length)*/}
                                {/*    {*/}
                                {/*        (subRoleList).filter((e: any) => e.roleId == role).map((e: any) => (*/}
                                {/*            <option value={e.id} key={e.id}> {e.name}</option>*/}
                                {/*        ))*/}
                                {/*    }*/}
                                {/*</select>*/}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-lg-3 control-label">
                                Contract
                            </label>
                            <div className="col-lg-9">
                                <div className="d-flex flex-row">
                                    2020
                                </div>
                                {/*<select className="form-select"*/}
                                {/*    {...register("contractId")}>*/}
                                {/*    if (contractList.length)*/}
                                {/*    {*/}
                                {/*        (contractList).map((e: any) => (*/}
                                {/*            <option value={e.id} key={e.id}> {e.name}</option>*/}
                                {/*        ))*/}
                                {/*    }*/}
                                {/*</select>*/}
                            </div>
                        </div><br />
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Standard Start Time*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller*/}
                        {/*            name="standardStartTime"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Standard start time") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="standardStartTime"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    popup={CustomPopup}*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.standardStartTime &&*/}
                        {/*            (<span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.standardStartTime.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*            )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Standard End Time*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller*/}
                        {/*            name="standardEndTime"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Standard end time") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="standardEndTime"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.standardEndTime && (*/}
                        {/*            <span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.standardEndTime.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Premium Start Time*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller*/}
                        {/*            name="premiumStartTime"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Premium start time") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="premiumStartTime"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.premiumStartTime && (*/}
                        {/*            <span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.premiumStartTime.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Premium End Time*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller*/}
                        {/*            name="premiumEndTime"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Premium end time") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="premiumEndTime"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.premiumEndTime && (*/}
                        {/*            <span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.premiumEndTime.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Normal Session Length*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller*/}
                        {/*            name="normalSessionLength"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Normal session length") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="normalSessionLength"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.normalSessionLength && (*/}
                        {/*            <span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.normalSessionLength.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        {/*<div className=" form-group row">*/}
                        {/*    <label className="col-lg-3 control-label justify-content-center">*/}
                        {/*        Premium Session Length*/}
                        {/*    </label>*/}
                        {/*    <div className="col-lg-9">*/}
                        {/*        <Controller */}
                        {/*            name="premiumSessionLength"*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: getRequiredErrorMessage("Premium session length") }}*/}
                        {/*            render={({ field }) => (*/}
                        {/*                <TimePicker*/}
                        {/*                    id="premiumSessionLength"*/}
                        {/*                    {...field}*/}
                        {/*                    format="HH:mm"*/}
                        {/*                    onChange={(event: any) => field.onChange(event.value)}*/}
                        {/*                    onBlur={field.onBlur}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.premiumSessionLength && (*/}
                        {/*            <span className="help-block m-b-none text-danger field-validation-valid">*/}
                        {/*                {errors.premiumSessionLength.message?.toString()}*/}
                        {/*            </span>*/}
                        {/*        )}*/}
                        {/*    </div>*/}
                        {/*</div><br />*/}
                        <div className="form-group row">
                            <div className=" col-sm-offset-3 px-2">
                                <button className="btn btn-secondary" onClick={() => navigate('/workhour')}>Cancel</button>
                                <button className="btn btn-primary ms-1" type="submit">Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}